<mat-dialog-content class="mt-4 mb-5">
  Souhaitez-vous que la modification de code LMod soit répercutée sur l'ensemble des données non clôturées?
</mat-dialog-content>
<div class="d-flex justify-content-center mt-4">
  <button class="btn-link mr-4" mat-button mat-dialog-close>Annuler</button>
  <button [mat-dialog-close]="0" class="btn-link mr-4" mat-button>Modifier sans répercuter</button>
  <button [mat-dialog-close]="1" class="btn" mat-button>Confirmer</button>
</div>
